export const AUTOMATION_CHANGE_FEATURE = 'automationChangeFeature'
